import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function cannotBeLongAndShortBuilder() {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Cannot be long and short simultaneously.
      </Body3>
    </td>
  );
}
